import React, { useState } from "react";
import {
  Box,
  Typography,
  Switch,
  TextField,
  Paper,
  Button,
  Divider,
} from "@mui/material";
import "./AccessControl.css";

const AccessControl = () => {
  const [startDate, setStartDate] = useState("");

  const [showProjection, setShowProjection] = useState(false);
  const [showComputation, setShowComputation] = useState(false);
  const [allowDownload, setAllowDownload] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);

  const [saved, setSaved] = useState(false);

  // Button disable logic
  const isButtonDisabled =
    saved ||
    !startDate ||
    (!showProjection &&
      !showComputation &&
      !allowDownload &&
      !allowEdit);

  const handleSave = () => {
    // yahan API call bhi ja sakti hai future me
    console.log("Settings Saved", {
      startDate,
      showProjection,
      showComputation,
      allowDownload,
      allowEdit,
    });

    setSaved(true);
  };

  return (
    <Box className="ac-wrapper">
      <Paper className="ac-card">
        {/* Start Date */}
        <Box className="ac-date-box">
          <TextField
            label="Financial Year Start Date"
            type="date"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              setSaved(false);
            }}
            InputLabelProps={{ shrink: true }}
            className="ac-date-input"
          />
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Switches */}
        <Box className="ac-switches-box">
          <Box className="ac-switch-row">
            <Typography className="ac-switch-label">
              Show Tax Projection to Employees
            </Typography>
            <Switch
              checked={showProjection}
              onChange={() => {
                setShowProjection(!showProjection);
                setSaved(false);
              }}
            />
          </Box>

          <Box className="ac-switch-row">
            <Typography className="ac-switch-label">
              Show Tax Computation to Employees
            </Typography>
            <Switch
              checked={showComputation}
              onChange={() => {
                setShowComputation(!showComputation);
                setSaved(false);
              }}
            />
          </Box>

          <Box className="ac-switch-row">
            <Typography className="ac-switch-label">
              Allow Employees to Download Tax Report
            </Typography>
            <Switch
              checked={allowDownload}
              onChange={() => {
                setAllowDownload(!allowDownload);
                setSaved(false);
              }}
            />
          </Box>

          <Box className="ac-switch-row">
            <Typography className="ac-switch-label">
              Allow Employees to Edit Declarations
            </Typography>
            <Switch
              checked={allowEdit}
              onChange={() => {
                setAllowEdit(!allowEdit);
                setSaved(false);
              }}
            />
          </Box>
        </Box>

        {/* Save Button */}
        <Box className="ac-button-box">
          <Button
            variant="contained"
            className="ac-save-btn"
            disabled={isButtonDisabled}
            onClick={handleSave}
          >
            {saved ? "Settings Saved" : "Save Settings"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AccessControl;
